import React, {ReactNode} from "react";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import PortalContext from "../../../PortalContext";
import {KeystoreViewer} from "../../../../shared/components/KeystoreViewer";
import {CertificateEntry} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import Translate from "../../../../shared/translation/Translate";
import Icon from "../../../../shared/components/Icon";
import AbstractDialog, {
	AbstractDialogProperties,
	AbstractDialogState
} from "../../../../shared/dialog/components/AbstractDialog";

export interface CertificateDialogProperties extends AbstractDialogProperties {
	context: PortalContext;
	certificates: Array<CertificateEntry>;
}

export class CertificateDialogDefinition extends AbstractDialog<CertificateDialogProperties, AbstractDialogState> {
	/**
	 * Render the dialog header
	 */
	protected renderHeader(): ReactNode {
		return (
			<div>
				<h1>
					<Icon icon={"icon-certificate"}/>
					<Translate {...this.props} data="certificate.title" namespace="dialog"/>
				</h1>
				<Button icon="icon icon-close" onClick={this.hide}/>
			</div>
		);
	}

	/**
	 * Render the dialog footer
	 */
	protected renderFooter(): ReactNode {
		return (
			<div className="p-col-12 p-grid">
				<div className="p-col-12 p-grid">
					<Button label={Translate.value("buttons.close")} icon="icon icon-close"
							onClick={() => this.hide()} className="dialog-button"/>
				</div>
			</div>
		);
	}

	public renderDialog(): ReactNode {
		let classList: Array<string> = ["certificate-dialog"];
		if (this.state.submitted) {
			classList.push("submitted");
		}

		return (
			<Dialog className={classList.join(" ")} visible={this.props.visible} onHide={this.hide} resizable={false}
					closeOnEscape={true} header={this.renderHeader()} footer={this.renderFooter()}
					appendTo={document.getElementById("root")}>
				<div className="p-grid">
					{this.renderError()}
					<fieldset className="p-col-12 p-grid">
						<div className="p-col-12 p-grid">
							<KeystoreViewer {...this.props} certificates={this.props.certificates}/>
						</div>
					</fieldset>
				</div>
			</Dialog>
		);
	}

	protected isValid(): boolean {
		return true;
	}
}

const CertificateDialog = React.memo(CertificateDialogDefinition,
	(prevProps: Readonly<CertificateDialogProperties>, nextProps: Readonly<CertificateDialogProperties>) => {
		if (!nextProps.visible && !prevProps.visible) {
			return true
		}

		return false;
	}
);

export default CertificateDialog;